<template>
	<div>
		<div class="foot_main">
			<span class="foot_text1">
				<ul class="website-box-list">
		            <li class="website-box-item">
						<el-dropdown style="font-size: 0.19rem;">
						  <span class="el-dropdown-link">
						    省直单位<img src="@/assets/img/fruit-transfer/icon_up.png" width=".2rem" height=".2rem">
						  </span>
						  <el-dropdown-menu class="project-dropdown" slot="dropdown">
						    <el-dropdown-item><a href="http://www.hunan.gov.cn/" target="_blank">省政府</a></el-dropdown-item>
						    <el-dropdown-item><a href="http://fgw.hunan.gov.cn/" target="_blank">省发展和改革委员会</a></el-dropdown-item>
						    <el-dropdown-item><a href="http://gxt.hunan.gov.cn/" target="_blank">省工业和信息化厅</a></el-dropdown-item>
						    <el-dropdown-item><a href="http://gov.hnedu.cn/" target="_blank">省教育厅</a></el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
		            </li>
		
		            <li class="website-box-item">
						<el-dropdown style="font-size: 0.19rem;">
						  <span class="el-dropdown-link">
						    市州科技局<img src="@/assets/img/fruit-transfer/icon_up.png" width=".2rem" height=".2rem">
						  </span>
						  <el-dropdown-menu class="project-dropdown" slot="dropdown">
						    <el-dropdown-item>
								<a href="http://kjj.changsha.gov.cn" target="_blank">长沙市科学技术局</a>
							</el-dropdown-item>
						    <el-dropdown-item>
								<a href="http://kjj.zhuzhou.gov.cn/" target="_blank">株洲市科学技术局</a>
							</el-dropdown-item>
						    <el-dropdown-item>
								<a href="http://xtst.xiangtan.gov.cn/" target="_blank">湘潭市科学技术局</a>
							</el-dropdown-item>
						    <el-dropdown-item>
								<a href="https://www.hengyang.gov.cn/kjj/" target="_blank">衡阳市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://www.yiyang.gov.cn/yyskjj/index.htm" target="_blank">益阳市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjj.changde.gov.cn/" target="_blank">常德市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjj.yueyang.gov.cn/kjj/index.htm" target="_blank">岳阳市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjj.shaoyang.gov.cn" target="_blank">邵阳市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjj.czs.gov.cn/" target="_blank">郴州市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjj.hnloudi.gov.cn/" target="_blank">娄底市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjj.yzcity.gov.cn/" target="_blank">永州市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="https://www.huaihua.gov.cn/kjj" target="_blank">怀化市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjj.zjj.gov.cn/" target="_blank">张家界市科学技术局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjj.xxz.gov.cn/" target="_blank">湘西自治州科学技术局</a>
							</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
		            </li>
		            <li class="website-box-item">
						<el-dropdown style="font-size: 0.19rem;">
						  <span class="el-dropdown-link">
						    各省科学技术厅网站<img src="@/assets/img/fruit-transfer/icon_up.png" width=".2rem" height=".2rem">
						  </span>
						  <el-dropdown-menu class="project-dropdown" slot="dropdown">
						    <el-dropdown-item>
								<a href="http://kw.beijing.gov.cn/" target="_blank">北京市科委</a>
							</el-dropdown-item>
						    <el-dropdown-item>
								<a href="http://kxjs.tj.gov.cn/" target="_blank">天津市科学技术局</a>
							</el-dropdown-item>
						    <el-dropdown-item>
								<a href="http://kjt.hebei.gov.cn/" target="_blank">河北省科技厅</a>
							</el-dropdown-item>
						    <el-dropdown-item>
								<a href="http://kjt.shanxi.gov.cn/" target="_blank">山西省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.nmg.gov.cn/" target="_blank">内蒙古自治区科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.ln.gov.cn/" target="_blank">辽宁省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.jl.gov.cn/" target="_blank">吉林省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://www.hljkjt.gov.cn/" target="_blank">黑龙江省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://stcsm.sh.gov.cn" target="_blank">上海市科委</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kxjst.jiangsu.gov.cn/" target="_blank">江苏省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.zj.gov.cn" target="_blank">浙江省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.ah.gov.cn/" target="_blank">安徽省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.fujian.gov.cn/" target="_blank">福建省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.jiangxi.gov.cn/" target="_blank">江西省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.shandong.gov.cn/" target="_blank">山东省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.henan.gov.cn/" target="_blank">河南省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.hubei.gov.cn/" target="_blank">湖北省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://gdstc.gd.gov.cn" target="_blank">广东省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://dost.hainan.gov.cn/" target="_blank">海南省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjj.cq.gov.cn/" target="_blank">重庆市科技局</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.sc.gov.cn/" target="_blank">四川省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.guizhou.gov.cn/" target="_blank">贵州省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.yn.gov.cn/" target="_blank">云南省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://sti.xizang.gov.cn/" target="_blank">西藏自治区科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.shaanxi.gov.cn/" target="_blank">陕西省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.gansu.gov.cn/" target="_blank">甘肃省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.qinghai.gov.cn/" target="_blank">青海省科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.nx.gov.cn/" target="_blank">宁夏回族自治区科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://kjt.xinjiang.gov.cn/" target="_blank">新疆维吾尔自治区科技厅</a>
							</el-dropdown-item>
							<el-dropdown-item>
								<a href="http://www.itc.gov.hk/gb/welcome.htm" target="_blank">香港创新科技署</a>
							</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
		            </li>
		        </ul>
			
			</span>
			<span class="foot_text2"> 主办单位：湖南省科学技术厅&nbsp;&nbsp;政府网站标识码：4300000012&nbsp;&nbsp;备案号：湘ICP备2021000521号-3 <br>
		  地址：湖南省长沙市岳麓大道233号&nbsp;&nbsp;联系电话：0731-88988999&nbsp;&nbsp;邮政编码：410013<br>
		  技术支持：湖南省科学技术信息研究所科技信息服务中心&nbsp;&nbsp;&nbsp;&nbsp;湘公网安备43010402000435号
			</span>
		</div>
	</div>
</template>

<script>
	import setRemPc from '@/api/setrem'
	export default {
		data() {
			return{
				
			}
		},
		created(){
		    // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
			setRemPc();
		    window.addEventListener('resize', setRemPc);//浏览器窗口大小改变时调用rem换算方法
		},
	}
</script>

<style lang="scss">
	.el-dropdown-menu {
		margin: 5px -30px 5px 0;
		/*width:2.5rem;*/
		text-align: center;
		border-radius: 0 0;
	}
	.el-popper .popper__arrow::after{
		 border-width:0;
	 }
	.el-popper .popper__arrow{
		border-width:0;
	}
	.el-popper.project-dropdown {
	  background-color: rgba(16, 86, 138, 0.8);  // 背景颜色
	  border: 0 solid #fff; 
	  .el-dropdown-menu__item { // 下拉菜单文字颜色
	    color: #fff !important;
	  }
	  .el-dropdown-menu__item a{ // 下拉菜单文字颜色
	    color: #fff !important;
	  }
	  .popper__arrow::after {
	    border-bottom-color: rgba(16, 86, 138, 0) !important;
	    border-top-color: rgba(16, 86, 138, 0) !important;
	  }
	  .el-dropdown-menu__item:not(.is-disabled):hover {
	    background: rgba(16, 86, 138, 0) !important;
	  }
	}
	.project-dropdown{
	  height:1.83rem;
	  overflow: auto;
	}
	.project-dropdown::-webkit-scrollbar{
	    width: 0.2rem;
	    /*height: 0.2rem;*/
	    background-color: #F4F4F4;
	}
	.project-dropdown::-webkit-scrollbar-track{
	    background-color: #F4F4F4;
    }
	.project-dropdown::-webkit-scrollbar-thumb{
		width: 0.2rem;
		height: 0.3rem;
		background-color: #CDCDCD;
	}
	.project-dropdown::-webkit-scrollbar-button{
		display: block;
		height:0.13rem;
	}
	.project-dropdown::-webkit-scrollbar-button:vertical:single-button:start {
		width: 0.3rem;
		background: url("~@/assets/img/t-arrow.png") 3px 5px no-repeat;
		cursor: pointer;
	}
	.project-dropdown::-webkit-scrollbar-button:vertical:single-button:end {
		width: 0.3rem;
		background: url("~@/assets/img/b-arrow.png") 3px 0 no-repeat;
		cursor: pointer;
	}
	.el-dropdown-link {
	    cursor: pointer;
	    color: #ffffff;
	  }
	.el-popper[x-placement^=top] {
		margin-bottom: 0.25rem;
	}
	.foot_main {
	    width: 100%;
	    /* background: url(/template/hnkj/default/images/indexNew/foot_bg.png) 100% no-repeat; */
	    background: none;
	    background-size: 100% 100%;
	    height: 2.3rem;
	    margin-top: 0.2rem;
	    background-color: #10568A;
	}
	.foot_main .foot_text1 {
	    text-align: center;
	    color: #fff;
	    font-size: .14rem;
	    font-family: SourceHanSansCN-Regular;
	    margin-top: 0.13rem;
	    margin-bottom: 0rem;
	}
	.foot_main > span {
	    width: 100%;
	    display: inline-block;
	}
	.foot_main .foot_text1 .website-box-list {
	    width: 10rem;
	    margin: 0 auto;
	    height: 0.51rem;
	}
	.website-box-list .website-box-item {
	    float: left;
	    width: 27%;
	    height: 0.3rem;
	    position: relative;
		margin-right:0.3rem;
		margin-top:0.12rem;
	}
	li {
	    list-style: none;
	}
	a {
	    text-decoration: none;
	}
	img {
	    border: 0;
	    vertical-align: middle;
	}
	.website-box-list .website-box-item > a {
	    width: 100%;
	    height: 100%;
	    line-height: .5rem;
	    text-align: center;
	    color: #fff;
	    font-size: .14rem;
	    display: block;
	    margin: 0;
	}
	.select_div {
	    width: 100%;
	    height: 1.77rem;
	    position: absolute;
	    bottom: 0.5rem;
	    background-color: #10568A;
	    opacity: .8;
	    padding: 0.1rem 0;
	    overflow-y: auto;
	}
	.foot_main .foot_text1 a {
	    text-align: center;
	    color: #fff;
	    font-size: .19rem;
	    font-family: SourceHanSansCN-Regular;
	    margin: 0 0.5rem;
	}
	.select_div a {
	    width: 100%;
	    height: 0.33rem;
	    line-height: .33rem;
	    display: block;
	    margin: 0!important;
	}
	.foot_main .foot_text2 {
	    color: #fff;
	    font-size: .19rem;
	    font-family: SourceHanSansCN-Regular;
	    text-align: center;
	    line-height: .4rem;
	}
	.el-dropdown-link img {
	    margin-left: 0.08rem;
	    width: 0.2rem;
	    height: 0.2rem;
	}
</style>